export const defaultPythonCode = `siblings = 2
print ("I have " + str(siblings) + " siblings.")

cousins = 8
print ("I have " + str(cousins) + " cousins.")
`;

export const defaultJavaScriptCode = `function setup() {
  createCanvas(400, 400);
  colorMode(HSB);
}

function draw() {
  background(220);
  noStroke();
  for (let i = 0; i < 12; i++){
    fill (360 - i * 25, 100, 100);
    rect (0, i * height / 12, width, height / 12);
  }
}
`;

export const defaultCodeTailwindStyle =
  "h-[21px] px-1 py-0.5 bg-transparent rounded items-center gap-2 inline-flex text-sm font-normal font-mono leading-none";
